import BatchProcessAlarmModal from './batch-process-alarm-modal.vue'
export default BatchProcessAlarmModal
